import { render } from "./AdminVoucher.vue?vue&type=template&id=40c7ffee&scoped=true"
import script from "./AdminVoucher.vue?vue&type=script&lang=js"
export * from "./AdminVoucher.vue?vue&type=script&lang=js"

import "./AdminVoucher.vue?vue&type=style&index=0&id=40c7ffee&scoped=true&lang=css"

import exportComponent from "C:\\SeaFarer\\SeaFarer\\AMDTransportation_FE\\amd_transportation_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c7ffee"]])

export default __exports__